class Pagination {
    constructor(pageIndex, pageSize, sortCol, sortType, pageCount = 0, totalCount = 0, filterCount = 0) {
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.sortCol = sortCol;
        this.sortType = sortType;
        this.pageCount = pageCount;
        this.totalCount = totalCount;
        this.filterCount = filterCount;
    }

    set(pagination) {
        this.pageIndex = pagination.pageIndex;
        this.pageSize = pagination.pageSize;
        this.sortCol = pagination.sortCol;
        this.sortType = pagination.sortType;
        this.pageCount = pagination.pageCount;
        this.totalCount = pagination.totalCount;
        this.filterCount = pagination.filterCount;

        return this;
    }

    setCount(records) {
        let rows = records && records.length ? records[0].rows : (records ? records : 0)

        this.pageCount = (Math.ceil(rows / this.pageSize))
        if (!this.totalCount || rows > this.totalCount)
            this.totalCount = rows;
        this.filterCount = rows;

        return this;
    }
}

export default Pagination;